var Vendd = (function (Vendd) {
    'use strict';

    var funcCookiesEnabled = true;
    if (window.ConsentsManager) {
        funcCookiesEnabled = window.ConsentsManager.cookiesStatus.functionalityCookies;
    }

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SetQuantity, Vendd.RequestOffer, function (envelope) {


        var options = {
            url: 'RequestForOfferService.svc/SetQuantityForItem',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SetQuantitySuccess(response));
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ModelChanged());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SetQuantityFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SetQuantity, Vendd.RequestOffer, function (envelope) {

    
        var options = {
            url: 'RequestForOfferService.svc/SetQuantityForItem',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SetQuantitySuccess(response));
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ModelChanged());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SetQuantityFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.AddRequestForOfferItem, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;


        var options = {
            url: 'RequestForOfferService.svc/AddRequestForOfferItem',
            data: {
                info: {
                    RequestForOfferId: envelope.message.data.RequestForOfferId,
                    RequestForOfferItemId: 0,
                    ProductCode: envelope.message.data.ProductCode,
                    Manufacturer: envelope.message.data.Manufacturer,
                    ProductName: envelope.message.data.ProductName,
                    ProductId: envelope.message.data.ProductId,
                    SKU: envelope.message.data.SKU,
                    Quantity: envelope.message.data.Quantity,
                    ItemIdentifier: envelope.message.data.ContentProviderCode
                }
            },

            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.AddRequestForOfferItemSuccess(response));
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ModelChanged());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.AddRequestForOfferItemFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.DeleteRequestForOfferItem, Vendd.RequestOffer, function (envelope) {

        var options = {
            url: 'RequestForOfferService.svc/DeleteRequestForOfferItem',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.DeleteRequestForOfferItemSuccess(response));
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ModelChanged());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.DeleteRequestForOfferItemFailure(response));
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.RequestForOfferFileUpload, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'RequestForOfferService.svc/RequestForOfferFileUpload',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.RequestForOfferFileUploadSuccess(response));
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ModelChanged());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.RequestForOfferFileUploadFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    Vendd.RequestOffer.GetNewRequestOfferItem = function (selectedItem) {

        if (!funcCookiesEnabled)
            return;

        var quantity = 1;
        if (selectedItem.MinQuantity != null) {
            quantity = selectedItem.MinQuantity;
        }
        var currentRequestOfferId = Cookies.get('rofid');
        var newrequestItem = {

            RequestForOfferId: currentRequestOfferId,
            RequestForOfferItemId: null,
            ProductCode: selectedItem.ErpProductCode,
            Manufacturer: selectedItem.Manufacturer.Name,
            ProductName: selectedItem.Title,
            ProductId: selectedItem.Id,
            SKU: selectedItem.VariantId,
            Quantity: quantity,
            ContentProviderCode: selectedItem.ContentProviderCode,
        };
        var observable = new Vendd.Observable(newrequestItem);
        return observable;
    };

    Vendd.RequestOffer.GetNewRequestOffer = function (requestForOfferId) {

        var newrequest = {

            RequestForOfferId: requestForOfferId,
            FileUploaded: null
        };
        var observable = new Vendd.Observable(newrequest);
        return observable;
    };

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.RequestForOfferSubmit, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'RequestForOfferService.svc/RequestForOfferSubmit',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.RequestForOfferSubmitSuccess(response));
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.ModelChanged());
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.RequestForOfferSubmitFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.SearchForProducts, Vendd.RequestOffer, function (envelope) {

        function onSuccess(response) {
            response.sender = envelope.sender;
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SearchForProductsSuccess(response));
        }

        function onFailure(response) {
            response.sender = envelope.sender;
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.SearchForProductsFailed(response));
        }

        var options = {
            url: 'api/RequestOffer/SearchForProducts?searchterm=' + envelope.message.data.searchTerm,
            method: 'GET',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.RequestOffer.Messages.AddOfferProducts, Vendd.RequestOffer, function (envelope) {

        if (!funcCookiesEnabled)
            return;

        var options = {
            url: 'api/RequestOffer/AddOfferProducts',
            data: envelope.message.data,
            method: 'POST',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.AddOfferProductsSuccess(response));
        };

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.RequestOffer, new Vendd.RequestOffer.Messages.AddOfferProductsFailure(response));
        };

        Vendd.Service.call(options);

        return;
    });

    return Vendd;

})(Vendd || {});